var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParkingMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "parkingMapSvg",
    width: 1440,
    height: 789,
    viewBox: "0 0 1440 789",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "parkingPlaces",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M494 478H459V552H494V478Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M494 403H459V478H494V403Z",
    fill: "#0B3D00"
  }), /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M530 478H495V552H530V478Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M530 403H495V478H530V403Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 5,
    d: "M573 478H538V552H573V478Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 6,
    d: "M573 403H538V478H573V403Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 7,
    d: "M609 478H573V552H609V478Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 8,
    d: "M609 403H573V478H609V403Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 9,
    d: "M652 478H617V552H652V478Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 10,
    d: "M652 403H617V478H652V403Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 11,
    d: "M688 478H652V552H688V478Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 12,
    d: "M688 403H652V478H688V403Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 13,
    d: "M723 478H688V552H723V478Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 14,
    d: "M723 403H688V478H723V403Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 15,
    d: "M767 478H732V552H767V478Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 16,
    d: "M767 403H732V478H767V403Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 17,
    d: "M848 478H813V552H848V478Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 18,
    d: "M848 403H813V478H848V403Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 19,
    d: "M883 478H848V552H883V478Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 20,
    d: "M883 403H848V478H883V403Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 21,
    d: "M918 478H883V552H918V478Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 22,
    d: "M918 403H883V478H918V403Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 23,
    d: "M962 478H926V552H962V478Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 24,
    d: "M962 403H926V478H962V403Z",
    fill: "#C0E3C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: 25,
    d: "M996.666 477.775H961.531V552.265H996.666V477.775Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 26,
    d: "M1031.8 477.775H996.67V552.265H1031.8V477.775Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 27,
    d: "M1036.03 442.637H961.531V477.772H1036.03V442.637Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 28,
    d: "M1036.03 407.5H961.531V442.635H1036.03V407.5Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 29,
    d: "M1206.36 92.3477H1131.88V127.483H1206.36V92.3477Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 30,
    d: "M1206.36 140.111H1131.88V175.246H1206.36V140.111Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 31,
    d: "M1206.36 175.25H1131.88V210.385H1206.36V175.25Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 32,
    d: "M1206.36 220.227H1131.88V255.362H1206.36V220.227Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 33,
    d: "M1206.36 255.363H1131.88V290.498H1206.36V255.363Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 34,
    d: "M1206.36 290.496H1131.88V325.631H1206.36V290.496Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 35,
    d: "M1206.36 335.473H1131.88V370.608H1206.36V335.473Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 36,
    d: "M1206.36 370.609H1131.88V405.744H1206.36V370.609Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 37,
    d: "M1206.36 416.145H1131.88V451.28H1206.36V416.145Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 38,
    d: "M1206.36 451.281H1131.88V486.416H1206.36V451.281Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 39,
    d: "M1206.36 486.418H1131.88V521.554H1206.36V486.418Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 40,
    d: "M1123.44 647.904H1088.3V722.394H1123.44V647.904Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 41,
    d: "M1088.3 647.904H1053.17V722.394H1088.3V647.904Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 42,
    d: "M1044.46 647.904H1009.32V722.394H1044.46V647.904Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 43,
    d: "M1009.32 647.904H974.186V722.394H1009.32V647.904Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 44,
    d: "M974.186 647.904H939.051V722.394H974.186V647.904Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 45,
    d: "M930.615 647.904H895.48V722.394H930.615V647.904Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 46,
    d: "M895.481 647.904H860.346V722.394H895.481V647.904Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 47,
    d: "M860.346 647.904H825.211V722.394H860.346V647.904Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 48,
    d: "M816.77 647.904H781.635V722.394H816.77V647.904Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 49,
    d: "M781.635 647.904H746.5V722.394H781.635V647.904Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 50,
    d: "M746.5 647.904H711.365V722.394H746.5V647.904Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 51,
    d: "M702.93 647.904H667.795V722.394H702.93V647.904Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 52,
    d: "M667.795 647.904H632.66V722.394H667.795V647.904Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 53,
    d: "M632.66 647.904H597.525V722.394H632.66V647.904Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 54,
    d: "M589.051 647.904H553.916V722.394H589.051V647.904Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 55,
    d: "M553.916 647.904H518.781V722.394H553.916V647.904Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 56,
    d: "M518.776 647.904H483.641V722.394H518.776V647.904Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 57,
    d: "M475.207 647.904H440.072V722.394H475.207V647.904Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 58,
    d: "M440.073 647.904H404.938V722.394H440.073V647.904Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 59,
    d: "M404.932 647.904H369.797V722.394H404.932V647.904Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 60,
    d: "M361.403 647.904H326.268V722.394H361.403V647.904Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 61,
    d: "M326.264 647.904H291.129V722.394H326.264V647.904Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 62,
    d: "M282.7 599.695H208.209V634.83H282.7V599.695Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 63,
    d: "M282.7 564.561H208.209V599.696H282.7V564.561Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 64,
    d: "M282.7 529.426H208.209V564.561H282.7V529.426Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 65,
    d: "M282.7 485.576H208.209V520.711H282.7V485.576Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 66,
    d: "M282.7 450.436H208.209V485.571H282.7V450.436Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 67,
    d: "M282.7 415.303H208.209V450.438H282.7V415.303Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 68,
    d: "M282.7 370.326H208.209V405.462H282.7V370.326Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 69,
    d: "M282.7 335.189H208.209V370.324H282.7V335.189Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 70,
    d: "M282.7 300.055H208.209V335.19H282.7V300.055Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 71,
    d: "M1077.02 301.699H1041.88V376.19H1077.02V301.699Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 72,
    d: "M1077.02 209.572H1041.88V284.063H1077.02V209.572Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: 73,
    d: "M1077.02 105.469H1041.88V179.959H1077.02V105.469Z",
    fill: "#8AB380"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1_pantry",
    d: "M629.425 90.2182V84.5977H659.645V114.113H616.07V90.2182H629.425Z",
    fill: "#D2E8F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "2_pantry",
    d: "M659.645 115.518V145.387H616.07V115.518H659.645Z",
    fill: "#D2E8F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "3_pantry",
    d: "M659.645 146.789V176.304H616.07V146.789H659.645Z",
    fill: "#D2E8F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4_pantry",
    d: "M659.645 180.52V207.926H613.965V180.52H659.645Z",
    fill: "#D2E8F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "5_pantry",
    d: "M940.729 273.281H918.244V242.852H940.729V273.281Z",
    fill: "#D2E8F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "6_pantry",
    d: "M964.626 273.281H942.141V242.852H949.871H964.626V273.281Z",
    fill: "#D2E8F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "7_pantry",
    d: "M988.519 242.86V273.281H966.029V242.852H988.519V242.86Z",
    fill: "#D2E8F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8_pantry",
    d: "M1012.41 242.852V273.281H989.926V242.86H1012.42V242.852H1012.41Z",
    fill: "#D2E8F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9_pantry",
    d: "M1034.9 273.281H1013.82V242.852H1034.9V273.281Z",
    fill: "#D2E8F7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingMap);
export default __webpack_public_path__ + "static/media/parkingMap.03990f24a9a318a26bd701d40d5b426f.svg";
export { ForwardRef as ReactComponent };